'use client';
import React, { FC, useEffect, useState } from 'react';
import styles from './EventCard.module.scss';
import Link from 'next/link';
import { format } from 'date-fns';
import Mark from '../../app/assets/icons/mark.svg';
import { mainPath } from '@/app/routes/MainPath';
import { EventArrElement } from '@/models/EventModels';
import Image from 'next/image';
import { rgbDataURL } from '@/helpers/functions';

interface EventCardProps {
  className?: string;
  isSlider?: boolean;
  event: EventArrElement;
  order: number;
  comeFrom: string;
}

const EventCard: FC<EventCardProps> = ({
  className = '',
  isSlider = false,
  event,
  order,
  comeFrom,
}) => {
  const [dateStart, setStartDate] = useState<string>('');
  const [monthStart, setStartMonth] = useState<string>('');

  useEffect(() => {
    if (event) {
      setStartDate(format(new Date(event.start), 'dd'));
      setStartMonth(format(new Date(event.start), 'MMM'));
    }
  }, [event]);

  return (
    <div className={`${styles.root} ${className}`}>
      <Link
        prefetch={false}
        href={`${mainPath.single_event.path}/${event.organization?.slug}/${event.id}`}>
        <div className={styles.background}>
          {event.poster_image && (
            <Image
              className={styles.image}
              priority={order <= 2}
              loading={order > 2 ? 'lazy' : 'eager'}
              placeholder="blur"
              blurDataURL={rgbDataURL(214, 215, 218)}
              width={400}
              height={183}
              src={event.poster_image}
              alt="poster"
            />
          )}
          {isSlider && (
            <div className={styles.date}>
              <b> {dateStart}</b>
              <span>{monthStart}</span>
            </div>
          )}
        </div>
      </Link>
      <div className={styles.eventdata}>
        {event.poster_image && (
          <Image
            width={200}
            height={200}
            className={styles.iconblock}
            src={event.organization.image}
            alt="band"
          />
        )}

        <Link
          prefetch={false}
          href={`${mainPath.organization.path}/${event.organization.slug}`}
          className={styles.textblock}>
          <h2 className={styles.title}>{event.title}</h2>
          <div className={styles.description}>
            <p className={styles.text}>{event.organization?.name}</p>
            <Image width={12} height={12} src={Mark} alt="mark" />
          </div>
          <p className={styles.address}>{event.address}</p>
        </Link>
        {!isSlider && (
          <div className={styles.date}>
            <b>{dateStart}</b>
            <span>{monthStart}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default EventCard;
